import React from "react";
import { withRouter } from "react-router-dom";
import { Grid, Typography } from "@material-ui/core";

import useStyles from "./styles";

const ListItem = ({
  title,
  value,
  image,
  icon,
  withLink,
  handleClick = () => {},
  history
}) => {
  const {
    liRoot,
    liItemWrapper,
    liTitle,
    liValue,
    liImageWrapper
  } = useStyles({ image });

  return (
    <Grid
      container
      className={liRoot}
      onClick={() => (withLink ? history.push(withLink) : handleClick())}
    >
      {icon && icon}
      {image && <Grid item container className={liImageWrapper} />}
      <Grid item xs container className={liItemWrapper}>
        <Typography component="span" className={liTitle} noWrap>
          {title}
        </Typography>
        {value && (
          <Typography component="span" className={liValue}>
            {value}
          </Typography>
        )}
      </Grid>
    </Grid>
  );
};

export default withRouter(ListItem);
